import PropTypes from 'prop-types';
import classes from './Header.module.css';

const SectionHeader = ({ backgroundColor, name }) => (
  <div className={classes.header} style={{ backgroundColor }}>
    <h3 className={classes.title}>{name}</h3>
    <hr className={classes.line} />
  </div>
);

SectionHeader.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default SectionHeader;
